<template>
    <div class="card-container">
        <ListHeader title="三级维度指标" >
            <template slot="right">
                <ActionButton2/>
            </template>
        </ListHeader>
        <div class="content">
            <div class="score">
                <Score />
            </div>
            <div class="divider"></div>
            <div class="text-content">
                教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习
                要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师
                通过引导学生猜测自己的名字由来，激发学生的表达动机，并自然过渡到学习如何讲述
                自己名字背后的故事，这与课文主题高度一致;
                教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习
                要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师
                通过引导学生猜测自己的名字由来，激发学生的表达动机，并自然过渡到学习如何讲述
                自己名字背后的故事，这与课文主题高度一致;
            </div>
            <div class="divider"></div>
            <div class="chart-container">
                <div ref="lineChart" class="line-chart"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
import ActionButton2 from './ActionButton2.vue';

export default {
    name: 'ReportStyle4',
    components: {
        ListHeader,
        Score,
        ActionButton2,
    },
    data() {
        return {
            lineChart: null,
            chartData: {
                categories: ['导入', '讲解', '互动', '练习', '总结'],
                values: [85, 92, 88, 90, 95]
            }
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.resizeChart);
    },
    beforeDestroy() {
        if (this.lineChart) {
            this.lineChart.dispose();
        }
        window.removeEventListener('resize', this.resizeChart);
    },
    methods: {
        initChart() {
            this.lineChart = echarts.init(this.$refs.lineChart);
            const option = {
                grid: {
                    left: '10%',
                    right: '10%',
                    top: '20%',
                    bottom: '20%'
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.categories,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: 'rgba(123, 168, 208, 0.8)',
                        fontSize: 12
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    max: 100,
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.2)'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: 'rgba(123, 168, 208, 0.8)',
                        fontSize: 12
                    }
                },
                series: [{
                    data: this.chartData.values,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 6,
                    lineStyle: {
                        color: '#0585F7',
                        width: 3
                    },
                    itemStyle: {
                        color: '#0585F7',
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(5, 133, 247, 0.5)'
                        }, {
                            offset: 1,
                            color: 'rgba(5, 133, 247, 0.1)'
                        }])
                    }
                }]
            };
            this.lineChart.setOption(option);
        },
        resizeChart() {
            if (this.lineChart) {
                this.lineChart.resize();
            }
        }
    }
}
</script>
<style lang="less" scoped>
.card-container {
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .content {
        height: 220px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 0 20px;

        .score {
            /* 固定宽度 */
            width: 124px;
            height: 108px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .divider {
            width: 1px;
            height: 180px;
            background: #043B6A;
            margin: 0 20px;
        }

        .text-content {
            /* 固定宽度 */
            width: 300px;
            font-family: Alibaba PuHuiTi 3.0;
            font-size: 14px;
            font-weight: normal;
            line-height: 200%;
            letter-spacing: 0em;
            color: #7BA8D0;
            /* 添加滚动功能 */
            max-height: 180px;
            overflow-y: auto;
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(0, 28, 53, 0.2);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(5, 133, 247, 0.5);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: rgba(5, 133, 247, 0.8);
            }
        }
        
        .chart-container {
            /* 剩余空间都给图表 */
            flex: 1;
            height: 180px;
            min-width: 200px;
        }
        
        .line-chart {
            width: 100%;
            height: 100%;
        }
    }
}
</style>